import { getMakiIcon } from "../../Map/Icons/Maki/MakiIcons";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MarkerOptionRenderer = option => {
  var _getMakiIcon;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("img", {
      width: "20px",
      height: "20px",
      style: {
        marginBottom: -5
      },
      src: (_getMakiIcon = getMakiIcon(option.value, "#000", 1, "#fff", 24, 24)) !== null && _getMakiIcon !== void 0 ? _getMakiIcon : option.value
    }), " ", option.value]
  });
};